module.exports = __webpack_public_path__ + "static/MC_futuros_beneficios-6aebe35ead85f2fcac0c46124adeb21b.jpg";